import { useEffect, useState } from "react";
import { Modal } from "@components/items/display/Modal";
import { X } from "lucide-react";
import { getCustomerQuota } from "@lib/stores";
import { Server } from "@wajeez/wajeez.microservices";
import CreditProducts from "./CreditProducts";
import { CreditCheckout } from "./CreditCheckout";
import SucessCreditPurchase from "./SucessCreditPurchase";

const CreditModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const [selectedProduct, setSelectedProduct] =
    useState<Server.ProductGroupWithProductsOutput | null>(null);
  const [isCheckout, setIsCheckout] = useState<boolean>(false);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const [isSuccessLoading, setIsSuccessLoading] = useState<boolean>(false);

  useEffect(() => {
    if (isOpen) {
      setSelectedProduct(null);
      setIsCheckout(false);
      setIsSuccess(false);
      setIsSuccessLoading(false);
    }
  }, [isOpen]);

  const onModalClose = () => {
    onClose();
  };

  const handleProductSelect = (
    product: Server.ProductGroupWithProductsOutput
  ) => {
    setSelectedProduct(product);
  };

  const handleProductSubmit = () => {
    setIsCheckout(true);
  };

  const handleCheckoutCancel = () => {
    setIsCheckout(false);
  };

  const handleCheckoutSuccess = async () => {
    setIsSuccess(true);
    setIsSuccessLoading(true);

    setTimeout(async () => {
      await getCustomerQuota();
      setIsSuccessLoading(false);
    }, 7000);
  };

  const renderContent = () => {
    if (isSuccess) {
      return (
        <SucessCreditPurchase
          onSubmit={onModalClose}
          isLoading={isSuccessLoading}
        />
      );
    }

    if (isCheckout && selectedProduct) {
      return (
        <CreditCheckout
          product={selectedProduct}
          onCancel={handleCheckoutCancel}
          onSuccess={handleCheckoutSuccess}
        />
      );
    }

    return (
      <CreditProducts
        selectedProduct={selectedProduct}
        onProductSelect={handleProductSelect}
        onProductSubmit={handleProductSubmit}
      />
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onModalClose}
      zIndexClassName="z-[70]"
      contentClassName={`${isCheckout ? "w-[80%]" : "w-[37%] max-w-[512px]"} h-[80%] cus-scrollbar-w-none [&>button]:hidden ${isSuccess && "h-[753px] w-[512px]"}`}
    >
      <div className="relative">
        <div
          className="absolute -start-[9px] -top-[9px] flex h-[45px] w-[45px] cursor-pointer items-center justify-center rounded-full bg-[#00000040] text-black dark:bg-[#FFFFFF40] dark:text-white"
          onClick={onModalClose}
        >
          <X size={20} strokeWidth={2.5} />
        </div>
        {renderContent()}
      </div>
    </Modal>
  );
};

export default CreditModal;
